import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/circle_background_left_hero.svg'
import _imports_1 from '@/assets/images/circle_background_right_hero.svg'
import _imports_2 from '@/assets/images/path_background_hero.svg'
import _imports_3 from '@/assets/images/portones_hero.png'
import _imports_4 from '@/assets/images/instalaciones_hero.png'
import _imports_5 from '@/assets/images/bobinados_hero.png'


const _hoisted_1 = {
  class: "hero",
  id: "hero"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"background__items\"><div class=\"background__items__circles\"><div class=\"background__items__circles__circle\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"background__items__circles__circle\"><img src=\"" + _imports_1 + "\" alt=\"\"></div></div><div class=\"background__items__path\"><img src=\"" + _imports_2 + "\" alt=\"\"></div></div>", 1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "container__text" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"container__images\"><div class=\"container__images__wrapper\"><div class=\"container__images__wrapper__row\"><img src=\"" + _imports_3 + "\" alt=\"\"><img src=\"" + _imports_4 + "\" alt=\"\"></div><img src=\"" + _imports_5 + "\" alt=\"\"></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('hero.mainText')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('hero.paragraphs'), (item) => {
          return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
        }), 128)),
        _createVNode(_component_Button, {
          text: 'Contacto',
          disable: false,
          link: '#contact'
        })
      ]),
      _hoisted_5
    ])
  ]))
}